// iter149 — Service-worker registration + "New version" update bridge.
// Only runs in production builds. The Craco InjectManifest plugin is
// gated on NODE_ENV too so dev / preview never ship a SW.
import { toast } from "sonner";

const SW_URL = "/service-worker.js";
const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

export function getAppVersion() {
  return APP_VERSION;
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  // Only in production — never in CRA dev or preview.
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register(SW_URL);
      // Fresh install — nothing to prompt.
      if (!reg.waiting && !reg.installing) return;

      const showUpdateSnack = () => {
        toast.info("New version available — tap to update", {
          duration: 20000,
          action: {
            label: "Update",
            onClick: () => {
              const waiting = reg.waiting;
              if (!waiting) return;
              waiting.postMessage({ type: "SKIP_WAITING" });
              // Reload once the new SW claims the page.
              navigator.serviceWorker.addEventListener("controllerchange", () => {
                window.location.reload();
              }, { once: true });
            },
          },
        });
      };

      if (reg.waiting) {
        showUpdateSnack();
      }
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            // There IS a currently controlling SW → this is an update.
            showUpdateSnack();
          }
        });
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("[sw] registration failed", err);
    }
  });
}

// Tell the SW to purge its API cache (called on logout).
export async function purgeApiCache() {
  if (typeof navigator === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    reg?.active?.postMessage({ type: "PURGE_API_CACHE" });
  } catch { /* best-effort */ }
}
